import React from 'react'

// components
import Section from 'components/atoms/Section'
import SectionItem from 'components/atoms/SectionItem'
import CartSummary from 'components/shared/Cart/Form/Summary'

const OrderSummary = props => {
  const {
    title,
    account,
    subheaderText,
    buttonText,
    buttonRoute,
    cartForm,
    sessions
  } = props

  return (
    <Section
      title={title}
      subheaderText={subheaderText}
      buttonText={buttonText}
      buttonRoute={buttonRoute}
    >
      <SectionItem>
        <CartSummary
          account={account}
          cartForm={cartForm}
          sessions={sessions}
        />
      </SectionItem>
    </Section>
  )
}

export default OrderSummary
